import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

let deferred = null;
const listeners = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; listeners.forEach((f) => f()); });
  window.addEventListener("appinstalled", () => { deferred = null; listeners.forEach((f) => f()); });
}

const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

function useInstallState() {
  const [, tick] = useState(0);
  useEffect(() => {
    const f = () => tick((n) => n + 1);
    listeners.add(f);
    const mq = window.matchMedia?.("(display-mode: standalone)");
    mq?.addEventListener?.("change", f);
    return () => { listeners.delete(f); mq?.removeEventListener?.("change", f); };
  }, []);
  if (isStandalone()) return "installed";
  if (deferred) return "prompt";
  return isIOS() ? "ios" : "none";
}

export function InstallAppButton({ variant = "dark", className = "" }) {
  const state = useInstallState();
  const [showIos, setShowIos] = useState(false);
  if (state === "installed" || state === "none") return null;

  const install = async () => {
    if (state === "ios") { setShowIos(true); return; }
    deferred.prompt();
    await deferred.userChoice.catch(() => null);
    deferred = null;
    listeners.forEach((f) => f());
  };
  const tone = variant === "dark"
    ? "text-slate-200 bg-white/[0.06] hover:bg-white/[0.12]"
    : "text-[#166db4] bg-[#166db4]/10 hover:bg-[#166db4]/15";

  return (
    <>
      <button onClick={install} data-testid="install-app-btn"
        className={`w-full flex items-center justify-center gap-2 rounded-md px-3 py-2 text-[13px] font-medium transition-colors duration-150 ${tone} ${className}`}>
        <Download size={15}/> Install Aplikasi
      </button>
      {showIos && (
        <div className="fixed inset-0 z-[60] bg-black/40 flex items-end sm:items-center justify-center p-4" onClick={() => setShowIos(false)} data-testid="install-ios-dialog">
          <div className="bg-white text-slate-800 rounded-xl w-full max-w-sm p-5 space-y-3" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <div className="font-semibold">Install di iPhone / iPad</div>
              <button onClick={() => setShowIos(false)} className="h-8 w-8 rounded-md flex items-center justify-center hover:bg-slate-100" data-testid="install-ios-close"><X size={16}/></button>
            </div>
            <ol className="text-sm text-slate-600 space-y-2 list-decimal pl-5">
              <li>Buka halaman ini di <b>Safari</b>.</li>
              <li>Ketuk tombol <b>Bagikan</b> <Share size={14} className="inline -mt-1"/> di bawah layar.</li>
              <li>Pilih <b>Tambah ke Layar Utama</b>, lalu ketuk <b>Tambah</b>.</li>
            </ol>
          </div>
        </div>
      )}
    </>
  );
}
